import _ from 'lodash'

export default {
  name: 'KPaginationTotal',
  inject: ['context'],
  computed: {
    total() {
      return this.context.total
    },
    current() {
      return this.context.current
    },
    pageSize() {
      return this.context.innerPageSize
    },
  },
  watch: {},
  methods: {},
  render() {
    const { total, current, pageSize } = this
    const customTotal = !_.isNil(this.$scopedSlots.default)
    const content = customTotal
      ? this.$scopedSlots.default({
        total,
        current,
        pageSize,
      })
      : `共 ${this.total} 条`

    return (
      <div class="km-pagination__total">
        {content}
      </div>
    )
  },
}
